// removed by extract-text-webpack-plugin
module.exports = {"root":"trailer__root","playButton":"trailer__playButton","playText":"trailer__playText","videoPlayer":"trailer__videoPlayer"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/show-page/components/trailer/styles.less
 ** module id = 445
 ** module chunks = 1
 **/